export default __webpack_public_path__ + "static/media/food-loader.656d5be3.gif";